import React from "react";
import { t } from "ttag";

import { FORM_ERROR_CLASS_NAME } from "../../../forms/classNames";

export const Cash = (): React.ReactNode => {
    return (
        <div className={FORM_ERROR_CLASS_NAME}>
            <p>
                <strong>
                    {t`Please enter payment information directly into the ERP.`}
                </strong>
            </p>
        </div>
    );
};
